import { Link as UiKitLink } from "@modernatx-internal/component-library";
import React from "react";

import { useAction } from "../hooks/useAction";
import { ContentComponentProps, LinkContent } from "../types";

type LinkProps = React.ComponentProps<typeof UiKitLink>;

export const Link: React.FC<ContentComponentProps<LinkContent>> = ({ action, ...props }) => {
  const { handleActionClick } = useAction(action);

  return <UiKitLink {...(props as LinkProps)} onClick={handleActionClick} />;
};
